/**
 * 企业打车相关页面专用
 */
export default [
  {
    name: 'index',
    path: '/enterprise/index',
    component: () =>
      import(
        /* webpackChunkName: "enterpriseIndex" */ '@/views/enterprise/index.vue'
      ),
    meta: { title: '小拉企业版' },
  },
  {
    name: 'info',
    path: '/enterprise/info',
    component: () =>
      import(
        /* webpackChunkName: "enterpriseInfo" */ '@/views/enterprise/info.vue'
      ),
    meta: { title: '小拉企业版' },
  },
];
